'use client'

import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Link, Option, Select } from 'base-ui'

import { useStoryblokRichTextAnchors } from '../../StoryblokRichText/useStoryblokRichTextAnchors'

import { useIntersectionObserversOnAnchors } from './useIntersectionObserversOnAnchors'

interface TableOfContentsProps {
  articleContainerId: string
}
const navigateToAnchor = (elementId: string): void => {
  document.querySelector(`#${elementId}`)?.scrollIntoView({
    behavior: 'smooth',
  })
}
export const TableOfContents: FC<TableOfContentsProps> = ({
  articleContainerId,
}) => {
  const anchors = useStoryblokRichTextAnchors(articleContainerId)
  const activeId = useIntersectionObserversOnAnchors(anchors)

  if (anchors.length === 0) {
    return null
  }

  return (
    <aside className="sticky top-24 mx-4">
      <Select
        className="mb-4 w-full p-3.5 text-m font-medium tablet:hidden"
        defaultValue={anchors[0].id}
      >
        {anchors.map((anchor) => (
          <Option
            key={anchor.id}
            onClick={() => {
              navigateToAnchor(anchor.id)
            }}
            value={anchor.id}
          >
            {anchor.textContent}
          </Option>
        ))}
      </Select>
      <h3 className="mb-6 hidden text-xl font-medium text-dark-primary-max tablet:block">
        <FormattedMessage id="general.label.ToC" />
      </h3>
      <ul className="hidden flex-col gap-4 tablet:flex">
        {anchors.map((anchor) => {
          return (
            <li key={anchor.id}>
              <Link
                className={clsx(
                  'border-l-2 pl-2 text-m font-medium no-underline',
                  activeId === anchor.id &&
                    'border-dark-brand text-dark-primary-max',
                  activeId !== anchor.id &&
                    'border-transparent text-dark-primary-strong',
                )}
                href={`#${anchor.id}`}
                onClick={(event) => {
                  event.preventDefault()
                  navigateToAnchor(anchor.id)
                }}
              >
                {anchor.textContent}
              </Link>
            </li>
          )
        })}
      </ul>
    </aside>
  )
}
